
import TableList from "@components/templates/tablelist";
import { HttpShipOBillPacking } from '@/service/boss/shipment'
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
        };
    },
    methods: {
        ajaxRequest: HttpShipOBillPacking,
    },
    computed: {
        columns() {
            return [{
                title: 'ID',
                key: 'id',
            }, {
                title: 'SKU',
                key: 'sku',
            }, {
                title: 'QTY',
                key: 'qty',
            }, {
                title: '箱条码',
                key: 'boxBarcode',
            }, {
                title: '托盘条码',
                key: 'trayBarcode',
            }, {
                title: '外箱毛重(G)',
                key: 'cartonGrossWeight',
            }, {
                title: '外箱尺寸(长*宽*高)',
                key: 'boxLength',
                render(h, { row }) {
                    const { cartonLength, cartonWidth, cartonHeight } = row;
                    return <div>
                        {cartonLength}cm * {cartonWidth}cm * {cartonHeight}cm
                    </div>
                }
            },

            ];
        },
    },
};




